<template>
    <div class="a-modal">
        <div class="popup__header popup__content--border-bot">
            <div class="form__item form__item--small-margin form__item--inline form__item--inline-mid">
                <el-popover trigger="manual"
                            placement="top"
                            width="300"
                            v-model="errors.name.isError"
                            :content="errors.name.message"
                            popper-class="add__error-popover">
                <span slot="reference" class="title title--changing title--sl popup__title"
                      v-if="visible">{{ wrapForm.name }}</span>
                    <el-input v-else
                              id="name"
                              slot="reference"
                              @focus="clearErrors"
                              maxlength="150"
                              class="title title--changing title--sl popup__title"
                              type="text"
                              v-model="wrapForm.name"
                    />
                </el-popover>
                <button class="btn btn--small" @click="changeTitle">
                    <svg width="17" height="17">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-pencil"></use>
                    </svg>
                </button>
            </div>
            <div v-if="id" class="form__label">{{ $lang('admin.addLocation.id') }} {{ id }}</div>
        </div>
        <div class="popup__content popup__content--border-bot">
            <div class="form__item form__item--no-margin form__item--inline">
                <div class="form__label form__label--mb0 a-filters__top-item">
                    <span>{{ $lang('admin.addLocation.addDate') }}</span>
                    <span class="form__label-text form__label-text--ml1">{{ formatDate(wrapForm.created_at) }}</span>
                </div>
                <div class="form__label form__label--mb0 a-filters__top-item">
                    <span>{{ $lang('admin.addLocation.updateDate') }}</span>
                    <span class="form__label-text form__label-text--ml1">{{ formatDate(wrapForm.updated_at) }}</span>
                </div>
            </div>
        </div>
        <div class="popup__content popup__content--border-bot">
            <div class="form__item a-filters__top-item a-filters__top-form f-checkbox">
                <span class="form__label">{{ $lang('admin.addLocation.type') }}</span>
                <el-select filterable
                           :loading-text="$lang('el-select.loading')"
                           :noDataText="$lang('el-select.noDataText')"
                           :noMatchText="$lang('el-select.noMatchText')"
                           v-model="wrapForm.cemetery_type_id">
                    <el-option v-for="item in locationTypes"
                               :key="item.id"
                               :label="$lang(item.title)"
                               :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="form__item a-filters__top-item a-filters__top-form f-checkbox">
                <span class="form__label">{{ $lang('admin.addLocation.region') }}</span>

                <el-select filterable
                           :loading-text="$lang('el-select.loading')"
                           :noDataText="$lang('el-select.noDataText')"
                           :noMatchText="$lang('el-select.noMatchText')"
                           v-model="wrapForm.region_id">
                    <el-option v-for="region in regions"
                               :key="region.id"
                               :label="region.name"
                               :value="region.id">
                    </el-option>
                </el-select>
            </div>
            <div class="form__item form__item--large-margin">
                <span class="form__label">{{ $lang('admin.addLocation.address') }}</span>
                <el-popover trigger="manual"
                            placement="top"
                            width="300"
                            v-model="errors.address.isError"
                            :content="errors.address.message"
                            popper-class="add__error-popover">
                    <el-input slot="reference"
                              id="address"
                              @focus="clearErrors"
                              maxlength="150"
                              :placeholder="$lang('admin.addLocation.address.placeholder')"
                              class="input input--big"
                              v-model="wrapForm.address"
                    ></el-input>
                </el-popover>
            </div>
            <div class="form__item form__item--wrap form__item--space-between form__item--large-margin">
                <div class="form__inner">
                    <span class="form__label">{{ $lang('admin.addLocation.coords') }}</span>
                    <div class="add__place-coords add__place-coords--mb0">
                        <el-input class="input input--small" v-model.number="wrapForm.latitude"></el-input>
                        <el-input class="input input--small" v-model.number="wrapForm.longitude"></el-input>
                    </div>
                </div>
                <div class="a-filters__top-item a-filters__top-form f-checkbox">
                    <span class="form__label">{{ $lang('admin.addLocation.filter') }}</span>
                    <el-select filterable
                               v-model="wrapForm.toro_id"
                               :placeholder="$lang('el-select.placeholder')"
                               :loading-text="$lang('el-select.loading')"
                               :noDataText="$lang('el-select.noDataText')"
                               :noMatchText="$lang('el-select.noMatchText')">
                        <el-option v-for="item in toros"
                                   :key="item.id"
                                   :label="item.title"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form__item add__place-item add__place-map">
                <div id="map"></div>
            </div>
        </div>
        <div class="popup__content popup__content--border-bot">
            <div class="form__item form__item--inline form__item--inline-column form__item--inline-half">
                <div class="form__label">{{ $lang('admin.addLocation.workTime') }}</div>
                <el-input class="form__label form__label-text" maxlength="150" v-model="wrapForm.working_hours"
                          :placeholder="$lang('admin.addLocation.workTime.placeholder')"></el-input>
                <el-switch
                    class="el-switch add__switch add__switch--margin-small switch switch--small"
                    v-model="wrapForm.pickup"
                    :inactive-text="$lang('admin.addLocation.pickup')">
                </el-switch>
            </div>
        </div>
        <div class="popup__content">
            <button class="btn--main-bg btn--middle" @click="handlerForm">
                {{ $lang('admin.addLocation.save') }}
            </button>
        </div>
    </div>
</template>

<script>
import helper from "../../../mixins/helper";
import errors from '../../../mixins/errors';
import initMap from "../../../mixins/initMap";
import {mapActions, mapGetters, mapMutations} from "vuex";
import Vue from "vue";
import ApiService from "../../../api/api";
import validator from "../../../mixins/validator";

export default {
    name: "addLocation",
    mixins: [helper, errors, initMap, validator],
    data: () => ({
        visible: true,
        toros: [],
        pickup: false,
        errors: {
            name: {
                isError: false,
                message: ''
            },
            address: {
                isError: false,
                message: ''
            },
        },
        rules: {
            name: [
                {required: true, message: Vue.prototype.$lang('admin.addLocation.enterName')},
            ],
            address: [
                {required: true, message: Vue.prototype.$lang('admin.addLocation.enterAddress')},
            ],
        },
        regions: []
    }),
    computed: {
        ...mapGetters('createLocation', [
            'form',
            'locationTypes'
        ]),
        id() {
            return this.$route.params.id ?? null;
        },
        wrapForm: {
            get: function () {
                return this.form;
            },
            set: function (val) {
                this.setForm(val);
            }
        },
    },
    methods: {
        ...mapMutations('createLocation', [
            'setForm'
        ]),
        ...mapActions('createLocation', [
            'createCemetery',
            'editCemetery',
            'getCemetery',
            'clearForm',
            'getLocationTypes'
        ]),
        ...mapMutations('locations', [
            'setRefreshAccess'
        ]),
        ...mapActions('pages', [
            'getAllToros',
        ]),
        handlerForm() {
            this.validate(() => {
                this.$loading(Vue.prototype.$optionsLoading);

                let promise = this.id
                    ? this.editCemetery(this.form)
                    : this.createCemetery(this.form);

                this.afterSaveCemetery(promise);
            }, {...this.wrapForm});
        },
        afterSaveCemetery(promise) {
            promise
                .then(() => {
                    this.$appNotify.success(Vue.prototype.$lang('admin.addLocation.success'));

                    this.setRefreshAccess(true);
                    this.clearForm();
                    this.$router.back();
                })
                .catch((error) => {
                    this.$appNotify.error(error.response.data);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        changeTitle() {
            this.visible = !this.visible;
        },
        getRegions() {
            ApiService.get('/regions').then((response) => {
                this.regions = response.data;
            });
        },
    },
    mounted() {
        this.getAllToros().then(response => {
            this.toros = response.data
        }).then(() => {
            this.getLocationTypes().then(() => {
                if (this.id) {
                    this.getCemetery(this.id)
                        .finally(() => window.ymaps.ready(() => this.initMap()))
                } else {
                    window.ymaps.ready(() => this.initMap());
                }
            });
        });

        this.getRegions();
    },
    beforeDestroy() {
        if (this.id) {
            this.clearForm();
        }
    }
}

</script>

